import React from "react";

import Job from "./job/general";
import JobsDetails from "./job/detail";
import Evolution from "./evolution/general";

import { Switch, Route, Redirect } from "react-router-dom";

import {
    LAYOUT_REPORT_STATS_JOBS_GENERAL,
    LAYOUT_REPORT_STATS_JOBS_PERIOD,
    LAYOUT_REPORT_STATS_EVOLUTION_GENERAL,
} from "../navigation";

const Router = (props) => (
    <>
        <Switch>
            <Route
                path={LAYOUT_REPORT_STATS_JOBS_PERIOD(":id")}
                render={(routeProps) => <JobsDetails {...props} {...routeProps} />}
            />

            <Route
                path={LAYOUT_REPORT_STATS_EVOLUTION_GENERAL}
                render={(routeProps) => <Evolution {...props} {...routeProps} />}
            />

            <Route
                path={LAYOUT_REPORT_STATS_JOBS_GENERAL}
                render={(routeProps) => <Job {...props} {...routeProps} />}
            />
            <Redirect to={LAYOUT_REPORT_STATS_JOBS_GENERAL} />
        </Switch>
    </>
);

export default Router;
